
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.753 40.165l-1.133-4.446a5.95 5.95 0 10-2.9-11.378l-3.6-14.107-.002-.009a1.644 1.644 0 00-.365-.677 1.613 1.613 0 00-1.623-.495l-4.506 1.149-.02.005-10.37 2.645-.009.002c-.842.223-1.408 1.086-1.172 1.987l.001.006 8.798 34.501.002.009c.223.842 1.086 1.408 1.988 1.172l.005-.001 14.891-3.798.009-.002c.798-.212 1.348-.998 1.202-1.848a1.69 1.69 0 00-.025-.128l-.004-.018-1.15-4.51a1.02 1.02 0 00-.017-.059zm-8.697-26.01l-.784-3.074-3.072.783a4.296 4.296 0 003.856 2.29zm.504 1.975a6.295 6.295 0 01-6.335-3.762L18.14 13.41a6.295 6.295 0 01-3.772 6.34l6.042 23.693a6.295 6.295 0 016.35 3.768l4.083-1.042a6.295 6.295 0 013.76-6.343l-1.097-4.304a5.953 5.953 0 01-2.547-9.993l-2.399-9.4zm5.813 17.542a.998.998 0 01.211.034 3.95 3.95 0 10-1.83-7.085.987.987 0 01-.124.096 3.951 3.951 0 001.742 6.955zm.733 8.129a4.297 4.297 0 00-2.289 3.855l3.072-.784-.783-3.071zm-14.18 3.616l.784 3.074 3.072-.783a4.297 4.297 0 00-3.856-2.291zm-7.052-27.645L13.09 14.7l3.074-.784a4.297 4.297 0 01-2.291 3.856zM44.85 14.15a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm-2.5 4.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"}})])
          )
        }
      }
    